'use strict'

// Dependancies
import GoogleMaps from './google-maps'
import MarkerClusterer from '@google/markerclustererplus'
import wpapi from './wpapi'
import fetch from 'isomorphic-unfetch'

// Modules
import listingsSearch from './listings.search'
import listingsFilter from './listings.filter'
import listingsResults from './listings.results'
import listingsPagination from './listings.pagination'

const self = {
  container : document.getElementById('listings-picker'),
  listings : [], // Contains all listings
  markers : [],
  activeMarkerIds : [],
  activeFilters : {}, // Contains type : value pairs for all selected filter options
  totalActiveListings : 0, // Is updated whenever a filter changes with the total listings shown
  collapsedClass : 'collapsed', // Storing the string to not have magic strings around the module
  userID : null, // Store the userID from the container elm
  totalListingsCount : null, // The total number of public_listings posts


  elms : {
    pickerTabsNav       : document.querySelector('.picker-tabs__nav'),
    pickerTabsContainer : document.querySelector('.picker-tabs'),
    totalListings       : document.querySelector('.total-listings'),
    customSearchTab     : document.querySelector('.tab[rel="custom-search"]'),
    listingsResults     : document.querySelector('.listings-results'),
    articleContainer    : document.querySelector('.listings-results .listings'),
    customSearchRadios  : document.querySelectorAll('.tab[rel="custom-search"] li.radio'),
    customSearchCheckboxes  : document.querySelectorAll('.tab[rel="custom-search"] li.checkbox'),
    customSearchMinMax  : document.querySelectorAll('.tab[rel="custom-search"] li.minMax select'),
    quickSearchRadios   : document.querySelectorAll('.tab[rel="quick-search"] li button'),
    buildingsButtons    : document.querySelectorAll('.tab[rel="buildings"] li button'),
    mlsNumberSubmit     : document.querySelector('.tab[rel="focus-search"] .mls-numbers button[type="submit"]'),
    addressSubmit       : document.querySelector('.tab[rel="focus-search"] .address button[type="submit"]'),
    btnSaveSearch       : [...document.querySelectorAll('.btn-save-search')],
    btnSaveAddressSearch : [...document.querySelectorAll('.btn-save-address-search')],
    savedSearchOverlay  : document.getElementById('savedSearchOverlay'),
    savedSearchForm     : document.querySelector('.state[rel="input"] form'),
    savedSearchInput    : document.querySelector('.state[rel="input"] #searchName'),
    savedSearchBtnClose : document.querySelector('.state[rel="input"] .btnClose'),
    btnShowAllHoods     : document.querySelector('.btn-show-all-hoods'),
    btnFilterResults    : document.querySelector('.btn-filter-results'),
    btnReset            : document.querySelector('.btn-reset')
  },


  map : {
    container : document.querySelector('#map .map-container'),
    api : null,
    obj : null,
    infowindow : null
  },


  init : () => {
    self.userID = self.container.getAttribute("data-user-id")
    self.totalListingsCount = parseInt( self.container.getAttribute("data-total-listings") )

    wpapi.init()

    self.registerEvents()
    self.setupMap()
  },


  registerEvents : () => {

    // Save Search
    if (self.elms.btnSaveSearch[0]) self.elms.btnSaveSearch.map( btn => btn.addEventListener("click", listingsSearch.showSavedSearchOverlay))
    if (self.elms.btnSaveAddressSearch[0]) self.elms.btnSaveAddressSearch.map(btn => btn.addEventListener('click', listingsSearch.saveAddressSearch));
    if (self.elms.savedSearchForm) self.elms.savedSearchForm.addEventListener("submit", listingsSearch.savedSearchName)
    if (self.elms.savedSearchBtnClose) self.elms.savedSearchBtnClose.addEventListener("click", listingsSearch.closeSearchOverlay);

    // Listings Picker
    self.elms.btnShowAllHoods.addEventListener('click', listingsFilter.toggleAllHoods)
    self.elms.mlsNumberSubmit.addEventListener("click", listingsFilter.mlsNumberSearch)
    self.elms.addressSubmit.addEventListener("click", listingsFilter.addressSearch)
    self.elms.pickerTabsNav.addEventListener("click", listingsFilter.changeTabs)
    self.elms.btnReset.addEventListener("click", listingsFilter.reset)
    self.elms.btnFilterResults.addEventListener("click", listingsResults.updateResults);
    [...self.elms.quickSearchRadios].forEach( option => option.addEventListener("click", listingsFilter.quickSearch) );
    [...self.elms.customSearchRadios].forEach( option => option.addEventListener("click", listingsFilter.updateFilterFromRadio) );
    [...self.elms.customSearchCheckboxes].forEach( option => option.addEventListener("click", listingsFilter.updateFilterFromCheckbox) );
    [...self.elms.customSearchMinMax].forEach( select => select.addEventListener("change", listingsFilter.updateFilterFromMinMax) );
    [...self.elms.buildingsButtons].forEach( button => button.addEventListener("click", listingsFilter.buildingSearch) );

    window.addEventListener("scroll", self.onScroll)

  },


  setupMap : () => {

    // Load Google Maps Api, create the map and infowindow objects
    // Then load the listings
    GoogleMaps.api().then( res => {
      self.map.api = res
      self.map.obj = new self.map.api.Map(self.map.container, GoogleMaps.mapArgs)
      self.map.infowindow = new self.map.api.InfoWindow()
      self.map.obj.addListener('tilesloaded', e => self.map.container.parentNode.classList.remove('loading-map'))
      self.setupInitialListings()
    })

  },

  setupInitialListings : () => {

    // Get Markers
    listingsFilter.getMarkersFromDB()
      .then( res => res.json() )

      // Then create the markers and store them in an array
      .then( json => self.createMarkersFrom(json))

      // Then remove the loading state
      .then( success => {

        listingsFilter.removeLoadingState()

        // Apply the search params to the filter if they exist
        if (location.search.length > 0) listingsSearch.setFiltersFromSearchParams()

      })

      .catch( err => console.log(err) )

    // Load results list
    listingsResults.appendResults()

      .then( success => {
        // listings loaded successfully
      })

      .catch( err => console.log(err) )

  },


  store : json => {
    self.listings = json.docs
    self.activeMarkerIds = json.markerIds
    self.totalActiveListings = json.markerIds.length
    listingsFilter.setTotalListingsDisplay()
  },

  createMarkersFrom : json => new Promise( (resolve, reject) => {

    json.map( listing => {

      // Create marker
      const marker = new self.map.api.Marker({
        position: new self.map.api.LatLng(listing.acf.lat,listing.acf.lng),
        icon : GoogleMaps.markerIcon
      })

      // Generate the HTML for the custom info window
      marker.infowindowContent = listingsResults.getInfoWindowHTML(listing)

      /// Store the post id to relate the two
      marker.postId = listing.id

      // Push the marker to the markers arr for marker clustering
      self.markers.push(marker)

      // Add click event to marker to toggle the infowindow
      marker.addListener("click", () => {
        self.map.infowindow.setContent(marker.infowindowContent)
        self.map.infowindow.open(self.map.obj, marker)
      })

    })

    // Add the markers to the MarkerClusterer library
    self.map.markerCluster = new MarkerClusterer(self.map.obj, self.markers, {
      imagePath : '/app/themes/jasonhutchison/assets/img/gmaps/m',
      maxZoom   : 16
    })

    self.map.markerCluster.setIgnoreHidden(true);

    resolve(true)
  }),


  createArticlesFrom : ({ listings }) => new Promise( (resolve, reject) => {
    let articleArr = []

    if ( listings.length === 0 ) return reject({ msg : 'There are no listings that match your criteria' })

    for (let listing of listings) {
      const article = listingsResults.getListingArticleHTML({ listing : listing })
      listing.el = article
      self.elms.articleContainer.appendChild(article)
    }

    self.loadImagesFrom({ listings : listings })

    return resolve(true)
  }),


  loadImagesFrom : ({ listings }) => {
    listings.map( listing => {
      const el = listing.el
      const imageContainer = el.querySelector('.bg-image')
      const imageUrl = imageContainer.getAttribute('data-image')

      if (!imageUrl) return

      const img = new Image()
            img.src = imageUrl

      imageContainer.style.backgroundImage = `url(${imageUrl})`

      img.onload = () => imageContainer.removeAttribute('data-image')

    })
  },


  onScroll : e => {

    // Collapse / Expand Filter
    if ( window.innerWidth > 767 ) {
      let filterTriggerPosition = window.pageYOffset > 90
      let containerIsCollapsed = self.container.classList.contains(self.collapsedClass)
      if (filterTriggerPosition && !containerIsCollapsed) listingsFilter.toggleFilterCollapse('add')
      if (!filterTriggerPosition && containerIsCollapsed) listingsFilter.toggleFilterCollapse('remove')
    }

    // Load the next page of listings
    const containerBottom = self.elms.articleContainer.getBoundingClientRect().bottom
    const windowOffset = window.innerHeight * 2
    if ( containerBottom - windowOffset < 0 && listingsPagination.loadMore && !listingsPagination.endOfResults ) {
      listingsResults.appendResults()
    }

  }


}

export default self
